module.exports = __webpack_public_path__ + "static/img/find_sg_ic_sub.f078fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/finds/find_sg_ic_sub.png
// module id = Qjjg
// module chunks = 1